import styled from "styled-components"


const Container = styled.div`
  width: 100%;
  display: flex;
  align-items: center;

  .menu-item{
    width: auto;
    display: flex;
    align-items: center;
    width: 20%;


    .round{
        width: 15px;
        height: 15px;
        border-radius: 50%;
        border: 1px solid ${({theme}) => theme.mainTextColor};
        position: relative;

        .menu-name{
          position: absolute;
          top: -50%;
          left: 50%;
          transform: translate(-50%, -100%);
          font-size: 14px;
          font-weight: var(--font-weight-xl);
          width: max-content;
        }
    }

    .seperator{
        width: calc(100% - 15px);
        border-top: 1px dashed #000;
    }


  }

  .active{
    background-color: rebeccapurple;
  }
`
const MenuItem = styled.div`
    width: auto;
    display: flex;
    align-items: center;
    width: 20%;

    .round{
        width: 15px;
        height: 15px;
        border-radius: 50%;
        border: 1px solid ${({isActiveName}) => isActiveName ? "#E85546" : "#000"};
        position: relative;
        background-color: ${({theme, isActiveName}) => isActiveName ? "#E85546" : theme.rotaPointColor};

        .menu-name{
          position: absolute;
          top: -50%;
          left: 50%;
          transform: translate(-50%, -100%);
          font-size: 14px;
          font-weight: var(--font-weight-xl);
          width: max-content;
          color: ${({theme, isActiveName}) => isActiveName ? "#E85546" : theme.mainTextColor};
        }
    }

    .seperator{
        width: calc(100% - 15px);
        border-top: 1px  ${({isActiveLine}) => isActiveLine ? "solid": "dashed"}  ${({theme,isActiveLine}) => isActiveLine ? "#E85546":  theme.mainTextColor};
    }
`


const MenuSection = ({setPhase, phase, menuList}) => {
  return (
    <Container>
      {
        menuList.map((item) => (
          <MenuItem isActiveLine={item.id <= phase.id -1} isActiveName={(item.id <= phase.id || item.id === phase.id)}>
                <div className="round" onClick={(e) => {e.stopPropagation(); setPhase({name: item.name, id: item.id})}}>
                  <div className="menu-name" onClick={(e) => {e.stopPropagation(); setPhase({name: item.name, id: item.id})}}>{item.name}</div>
                </div>
                {
                  item.id !== 6 && 
                  <div className="seperator"></div>
                }

          </MenuItem>
        ))
      }
    </Container>
  )
}

export default MenuSection